var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.knowledgeInfo.Statistics
    ? _c(
        "div",
        {
          staticClass: "qa-list-bar",
          class: {
            "hide-bar": _vm.CallCommentInput,
            "higher-zindex": _vm.showCocTip
          }
        },
        [
          _c(
            "div",
            { staticClass: "qa-list-inp", on: { click: _vm.callCommentInput } },
            [_vm._v(_vm._s(_vm.cPlaceholder))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "qa-list-btn" }, [
            _c(
              "div",
              {
                staticClass: "list-btn",
                class: {
                  "list-btn-active": _vm.knowledgeInfo.Statistics.IsCollection
                },
                on: { click: _vm.collect }
              },
              [
                _vm.knowledgeInfo.Statistics.IsCollection
                  ? _c("img", {
                      staticClass: "menu-svg-icon",
                      attrs: {
                        src: require("../../static/images/ic_07_nor.png")
                      }
                    })
                  : _c("img", {
                      staticClass: "menu-svg-icon",
                      attrs: {
                        src: require("../../static/images/ic_06_nor.png")
                      }
                    }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.knowledgeInfo.TotalCollectionCount))
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "list-btn",
                class: {
                  "list-btn-active": _vm.knowledgeInfo.Statistics.IsPraise
                },
                on: {
                  click: function($event) {
                    return _vm.ThumbUpDown(true)
                  }
                }
              },
              [
                _c("i", { staticClass: "list-btn-icon thumb-up-icon" }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.knowledgeInfo.Statistics.PraiseCount))
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "list-btn",
                class: {
                  "list-btn-active": _vm.knowledgeInfo.Statistics.IsStepOn
                },
                on: {
                  click: function($event) {
                    return _vm.ThumbUpDown(false)
                  }
                }
              },
              [
                _c("i", { staticClass: "list-btn-icon thumb-down-icon" }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.knowledgeInfo.Statistics.StepOnCount))
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("transition", { attrs: { name: "collect-slide-fade" } }, [
            _vm.showPopTip
              ? _c(
                  "div",
                  { staticClass: "collect-tip", on: { click: _vm.IKnewIt } },
                  [
                    _vm._v(
                      "\n                点击收藏，方便访问\n                "
                    ),
                    _c("i", { staticClass: "close-icon" }),
                    _vm._v(" "),
                    _c("span")
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("transition", { attrs: { name: "favorite-guide-fade" } }, [
            _vm.showCocTip
              ? _c("div", { staticClass: "favorite-guide-wrapper" }, [
                  _c("div", { staticClass: "favorite-guide" }, [
                    _c("div", {
                      staticClass: "fg-bot",
                      on: { click: _vm.IKnewThat }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "close-icon ",
                    on: { click: _vm.IKnewThat }
                  })
                ])
              : _vm._e()
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-0d0fc670", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-0d0fc670","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/releaveRecover.vue
// module id = null
// module chunks = 